"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyButton = void 0;
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _hooks = require("./hooks");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ARIA_LABEL = 'aria-label';
const BuyButton = ({
  buyTitle,
  disabledQuantity,
  reserveTitle,
  formattedPrice,
  productCode,
  productName,
  disabled: propsDisabled,
  loading: propsLoading,
  loadingEvents,
  maxValue: propsMaxValue,
  initialQuantity,
  isReserve,
  onlyButton,
  placement,
  className,
  onClick: propsOnClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    counterValue,
    disabled: shoppingPropsDisabled,
    loading: shoppingPropsLoading,
    maxQuantity: shoppingPropsMaxQuantity,
    setCounterValue
  } = (0, _hooks.useShoppingProps)({
    initialQuantity,
    loadingEvents,
    productCode
  });
  const maxQuantity = propsMaxValue ?? shoppingPropsMaxQuantity;
  const onCounterBlur = (0, _react.useCallback)(() => {
    if (counterValue === undefined || counterValue === '' || counterValue === '-') {
      setCounterValue(_constants.COUNTER_MIN_VALUE);
    }
  }, [counterValue, setCounterValue]);
  const onCounterChange = (0, _react.useCallback)(currentValue => {
    const count = (0, _utils.parseCounterValue)(currentValue);
    if (count === undefined) {
      setCounterValue('');
    } else {
      setCounterValue(count > maxQuantity ? maxQuantity : count);
    }
  }, [maxQuantity, setCounterValue]);
  const onBuyButtonClick = (0, _react.useCallback)(() => {
    const quantity = (0, _utils.parseCounterValue)(counterValue);
    if (quantity == null) {
      return;
    }
    if (propsOnClick) {
      propsOnClick(quantity);
    } else {
      window.dispatchEvent(new CustomEvent(AddToBasketEvent.Name, {
        detail: {
          itemCode: productCode,
          quantity,
          localName: productName,
          placement,
          formattedPrice: formattedPrice ?? '',
          globalName: ''
        }
      }));
    }
  }, [counterValue, formattedPrice, placement, productCode, productName, propsOnClick]);
  const loading = Boolean(propsLoading) || shoppingPropsLoading;
  const disabled = (0, _react.useMemo)(() => Boolean(propsDisabled) || shoppingPropsDisabled || loading, [loading, propsDisabled, shoppingPropsDisabled]);
  const testId = (0, _react.useMemo)(() => getTestId(isReserve ? _constants.RESERVE_BUTTON : _constants.BUY_BUTTON), [getTestId, isReserve]);
  return onlyButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.LoadingButton, {
    fullWidth: true,
    className: className,
    "data-testid": testId,
    variant: "contained",
    color: "primary",
    disabled: disabled,
    loading: loading,
    onClick: onBuyButtonClick,
    children: isReserve ? reserveTitle : buyTitle
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SplitButton, {
    fullWidth: true,
    className: className,
    buttonContent: isReserve ? reserveTitle : buyTitle,
    disabled: disabled,
    "data-testid": testId,
    loading: loading,
    size: "medium",
    onClick: onBuyButtonClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.QuantityPicker, {
      expandOnFocus: true,
      "data-testid": getTestId(_constants.BUY_BUTTON_COUNTER),
      disabled: disabled || disabledQuantity,
      maxValue: maxQuantity,
      minValue: _constants.COUNTER_MIN_VALUE,
      size: "large",
      value: counterValue,
      variant: "text",
      DecreaseIconButtonProps: {
        [ARIA_LABEL]: '-'
      },
      IncreaseIconButtonProps: {
        [ARIA_LABEL]: '+'
      },
      InputProps: {
        inputProps: {
          [ARIA_LABEL]: 'Quantity'
        }
      },
      onBlur: onCounterBlur,
      onChange: onCounterChange
    })
  });
};
exports.BuyButton = BuyButton;
